
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    list: {
      type: Array,
      required: true
    },
    listCount: {
      type: Number
    },
    propsList: {
      type: Array,
      required: true
    },
    showIndexColumn: Boolean,
    showSelectColum: Boolean,
    title: String,
    page: {
      type: Object,
      default: () => ({
        pageSize: 10,
        currentPage: 1
      })
    },
    childrenProp: {
      type: Object,
      default: () => ({
        rowKey: 'id',
        treeProp: {
          children: 'children'
        }
      })
    },
    showFooter: {
      type: Boolean,
      default: true
    }
  },
  emits: ['selectionChange', 'update:page'],
  setup(props, { emit }) {
    const handleSelectionChange = (value: any) => {
      emit('selectionChange', value)
    }

    const handleSizeChange = (pageSize: number) => {
      emit('update:page', { ...props.page, pageSize })
    }

    const handleCurrentChange = (currentPage: number) => {
      emit('update:page', { ...props.page, currentPage })
    }

    return {
      handleSelectionChange,
      handleSizeChange,
      handleCurrentChange
    }
  }
})
